import { Button, Col, Form, Modal, Row } from "react-bootstrap";
// css
import styles from "./ExportConfirm.module.scss";
import { CloseIcon } from "Assets/icons";
import { Link, useNavigate } from "react-router-dom";
import { MANAGE_EXPORT } from "config/paths";

const ExportConfirmModal = ({ show, setShow }) => {
    const navigate = useNavigate();

    const handlePopup = () => setShow(!show);

    const handleNavigateToExport = () => {
        setShow(false);
        navigate('/manage-export'); // <- Update this route according to your app
    };

    return (
        <>
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable="true"
                size="md"
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                    <Button
                        onClick={handlePopup}
                        className="border-0 p-0 position-absolute"
                        variant="transparent"
                        style={{ right: 15, top: 5 }}
                    >
                        <CloseIcon />
                    </Button>
                    <div className="d-flex flex-column justify-content-center align-items-center text-center p-4">
                        <h5 className="m-0 fw-bold themeBlue my-2">
                            Export request created successfully,
                            Please check the <Link to={MANAGE_EXPORT} className="themeClr">export section</Link>.
                        </h5>
                    </div>
                    <div className="d-flex justify-content-center">
                        <Button
                            onClick={handlePopup}
                            className={`fw-sbold d-flex align-items-center justify-content-center commonBtn`}
                        >
                            Close
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ExportConfirmModal;
